import React from 'react';
import _ from 'lodash';

import ProductFilter from '../../common/menu/products-filter';

const { Order, UI } = Mobi2Go;

class MenuCategories extends React.Component {
    constructor(...args) {
        super(...args);

        this.state = {
            categories: [],
            selected_category_id: null,
        };

        this.order_event_listeners = {
            updateMenu: this.updateState,
            updateMenuRestrictions: this.updateState,
            updateExpectedAt: this.updateState,
            updateMenuTierId: this.updateState,
        };
    }

    componentWillUnmount() {
        UI.unbind('showCategory', this.setSelectedCategory);
        Order.unbind(this.order_event_listeners);
    }

    componentDidMount() {
        UI.bind('showCategory', this.setSelectedCategory);
        Order.bind(this.order_event_listeners);
        this.updateState();
    }

    componentDidUpdate() {
        this.triggerMenuCategoriesViewRendered();
    }

    triggerMenuCategoriesViewRendered() {
        UI.trigger('menuCategoriesViewRendered');
    }

    updateState = () => {
        const categories = Order.getMenu().getCategories();
        categories.set(
            categories.filter(category => {
                const products = ProductFilter(
                    category.getProducts().toArray()
                );
                return products.length > 0;
            })
        );
        let { selected_category_id } = this.state;

        if (
            categories.getLength() > 0 &&
            (!selected_category_id ||
                !categories.find({ id: selected_category_id }))
        ) {
            selected_category_id = categories.first().id;
        }
        this.setState({
            categories,
            selected_category_id,
        });
    };

    setSelectedCategory = id => {
        if (!_.isNumber(id)) {
            const category = Order.getMenu()
                .getCategories()
                .getByName(id);

            if (!category) {
                return;
            }
            id = category.id;
        }

        this.setState({
            selected_category_id: id,
        });
    };

    onCategoryClick = category_id => {
        UI.trigger('showCategory', category_id);
    };

    render() {
        const { categories, selected_category_id } = this.state;

        return [
            categories.map(category => {
                const is_active = category.id === selected_category_id;
                return (
                    <a
                        key={category.id}
                        data-category={category.id}
                        data-category-name={category.backend_name}
                        data-tags={category.tags.join(' ')}
                        className={`m2g-menu-category-item m2g-nav-list-item m2g-nav-list-item--hoverable${
                            is_active ? ' m2g-nav-list-item--active' : ''
                        }`}
                        onClick={() => this.onCategoryClick(category.id)}
                    >
                        {category.name}
                    </a>
                );
            }),
        ];
    }
}

export default MenuCategories;
